import { jsx as e, jsxs as t } from "react/jsx-runtime";
import * as r from "react";
import { MoreHorizontal as m, ChevronRight as c, ChevronLeft as p } from "lucide-react";
import { cn as n } from "../../../lib/utils.js";
import { buttonVariants as g } from "../button/Button.js";
const d = ({ className: i, ...a }) => e("nav", { role: "navigation", "aria-label": "pagination", className: n("mx-auto flex w-full justify-center", i), ...a });
d.displayName = "Pagination";
const N = r.forwardRef(({ className: i, ...a }, s) => e("ul", { ref: s, className: n("flex flex-row items-center gap-1", i), ...a }));
N.displayName = "PaginationContent";
const f = r.forwardRef(({ className: i, ...a }, s) => e("li", { ref: s, className: n("", i), ...a }));
f.displayName = "PaginationItem";
const o = ({ className: i, isActive: a, size: s = "icon", ...l }) => e("a", { "aria-current": a ? "page" : void 0, className: n(g({
  variant: a ? "outline" : "ghost",
  size: s
}), i), ...l });
o.displayName = "PaginationLink";
const P = ({ className: i, ...a }) => t(o, { "aria-label": "Go to previous page", size: "md", className: n("gap-1 pl-2.5", i), ...a, children: [e(p, { className: "h-4 w-4" }), e("span", { children: "Previous" })] });
P.displayName = "PaginationPrevious";
const h = ({ className: i, ...a }) => t(o, { "aria-label": "Go to next page", size: "md", className: n("gap-1 pr-2.5", i), ...a, children: [e("span", { children: "Next" }), e(c, { className: "h-4 w-4" })] });
h.displayName = "PaginationNext";
const u = ({ className: i, ...a }) => t("span", { "aria-hidden": !0, className: n("flex h-9 w-9 items-center justify-center", i), ...a, children: [e(m, { className: "h-4 w-4" }), e("span", { className: "sr-only", children: "More pages" })] });
u.displayName = "PaginationEllipsis";
export {
  d as Pagination,
  N as PaginationContent,
  u as PaginationEllipsis,
  f as PaginationItem,
  o as PaginationLink,
  h as PaginationNext,
  P as PaginationPrevious
};
//# sourceMappingURL=Pagination.js.map
